import { Alert, Button, Card } from 'antd';

import { SyncSummary } from '@hooks-api';

import * as S from './styled';

interface Props {
  summary: SyncSummary | null;
  failed: boolean;
  /** We stopped waiting after the 30s ceiling; the job may still finish. */
  timedOut?: boolean;
  onDismiss: () => void;
}

/**
 * Ephemeral result of the last sync in this session — populated from the job
 * poll, dismissed on demand or reload. There is no persisted sync history.
 */
const SyncResult = ({ summary, failed, timedOut, onDismiss }: Props) => {
  if (!summary && !failed && !timedOut) return null;

  return (
    <Card
      size="small"
      title="Sync result"
      extra={
        <Button type="link" size="small" onClick={onDismiss}>
          Dismiss
        </Button>
      }
    >
      {failed ? (
        <Alert
          type="error"
          showIcon
          message="Sync failed"
          description="The full-rewrite job did not complete. Check the job logs and try again."
        />
      ) : timedOut ? (
        <Alert
          type="warning"
          showIcon
          message="Still running"
          description="The sync didn’t confirm within 30 seconds. It may still finish in Listmonk — check there, or run the sync again."
        />
      ) : (
        summary && (
          <S.Metrics>
            <S.Metric>
              <S.MetricValue tone="added">+{summary.added}</S.MetricValue>
              <S.MetricLabel>Added</S.MetricLabel>
            </S.Metric>
            <S.Metric>
              <S.MetricValue>{summary.updated}</S.MetricValue>
              <S.MetricLabel>Updated</S.MetricLabel>
            </S.Metric>
            <S.Metric>
              <S.MetricValue tone="removed">{summary.removed}</S.MetricValue>
              <S.MetricLabel>Removed</S.MetricLabel>
            </S.Metric>
            <S.Metric>
              <S.MetricValue>{summary.total}</S.MetricValue>
              <S.MetricLabel>Total</S.MetricLabel>
            </S.Metric>
          </S.Metrics>
        )
      )}
    </Card>
  );
};

export default SyncResult;
